import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { findIcon } from '../../../common/constants';
import OptionsSelectButton from './options-select-button';
import { IOption } from '../../../../models/product-detail';

interface IDualSelectProps {
    optionType: IOption;
}

export default function DualSelect({ optionType }: IDualSelectProps) {
    return optionType.items.length === 1 ? (
        <h4>
            <FontAwesomeIcon
                icon={findIcon('fad', 'check')}
                className="font-green"
            />{' '}
            {optionType.items[0].name}
        </h4>
    ) : (
        <OptionsSelectButton
            label={optionType.name}
            name={optionType.name}
            selectedOption={optionType.items[0].name}
            options={Array.from(
                new Set(
                    optionType.items.filter((x) => {
                        if (
                            x.isAvailableLeft &&
                            x.isAvailableRight &&
                            !x.hidden
                        )
                            return {
                                value: x.id,
                                text: x.name,
                            };
                    })
                )
            )}
            onChange={() => null}
            isProductOptions={true}
        />
    );
}
